import { render, staticRenderFns } from "./auditBox.vue?vue&type=template&id=2a979701"
import script from "./auditBox.vue?vue&type=script&lang=js"
export * from "./auditBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports